import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import { usePreferences } from "@hooks";
import { useUserDetails } from "@sdk/react";
import { LocalePicker } from "@temp/@next/components/molecules";
import { usePrismicLayout } from "@temp/@prismic/templates/PrismicLayout/hooks/usePrismicLayout";
import classNames from "classnames";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import Media from "react-media";
import { OverlayContext, OverlayTheme, OverlayType } from "..";
import { smallScreen } from "../../globalStyles/scss/variables.scss";
import chevronUrl from "../../images/chevron-left.svg";
import { FLAGS_DICTIONARY } from "../MainMenu/FlagsDictonary";
import { RegionPicker } from "../RegionsPicker";
import { TabTypes } from "./types";
export var NavLocales = function NavLocales() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showLocalesMenu = _useState2[0],
      setShowLocalesMenu = _useState2[1];

  var _useState3 = useState(TabTypes.region),
      _useState4 = _slicedToArray(_useState3, 2),
      currentTabPane = _useState4[0],
      setCurrentTabPane = _useState4[1];

  var _usePrismicLayout = usePrismicLayout(),
      layout = _usePrismicLayout.layout;

  var _useUserDetails = useUserDetails(),
      user = _useUserDetails.data;

  var _usePreferences = usePreferences(),
      preferences = _usePreferences.preferences;

  var intl = useIntl();
  return React.createElement(OverlayContext.Consumer, null, function (overlayContext) {
    return React.createElement("div", {
      className: "side-nav__locale"
    }, !user && React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return overlayContext.show(OverlayType.login, OverlayTheme.modal);
      }
    }, intl.formatMessage(_defineProperty({
      defaultMessage: "Log in to account",
      "id": "components.MobileNav.NavLocales.4102932148"
    }, "id", "components.MobileNav.NavLocales.4102932148"))), React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        setShowLocalesMenu(true);
      }
    }, React.createElement("img", {
      src: FLAGS_DICTIONARY[preferences.locale],
      alt: ""
    })), React.createElement(Media, {
      query: {
        minWidth: smallScreen
      }
    }, function (matches) {
      if (matches) {
        return showLocalesMenu ? React.createElement("div", {
          className: "locales"
        }, React.createElement("button", {
          className: "locales__close-btn",
          type: "button",
          onClick: function onClick() {
            setShowLocalesMenu(false);
          }
        }, React.createElement("img", {
          src: chevronUrl,
          alt: ""
        })), React.createElement("div", {
          className: "locales__regions"
        }, React.createElement("div", {
          className: "locales__item-top"
        }, React.createElement("h5", {
          className: "locales__item-title"
        }, layout === null || layout === void 0 ? void 0 : layout.region_title), React.createElement("p", {
          className: "locales__item-subtitle"
        }, layout === null || layout === void 0 ? void 0 : layout.region_description)), React.createElement(RegionPicker, null)), React.createElement("div", {
          className: "locales__languages"
        }, React.createElement("div", {
          className: "locales__item-top"
        }, React.createElement("h5", {
          className: "locales__item-title"
        }, intl.formatMessage(_defineProperty({
          defaultMessage: "Language",
          "id": "components.MobileNav.NavLocales.604081953"
        }, "id", "components.MobileNav.NavLocales.604081953")))), React.createElement(LocalePicker, {
          onPicked: overlayContext.hide
        }))) : null;
      }

      return showLocalesMenu ? React.createElement("div", {
        className: "locales"
      }, React.createElement("div", {
        className: "locales__tabs"
      }, React.createElement("button", {
        className: "locales__close-btn",
        type: "button",
        onClick: function onClick() {
          setShowLocalesMenu(false);
        }
      }, React.createElement("img", {
        src: chevronUrl,
        alt: ""
      })), React.createElement("button", {
        className: classNames({
          tabs__button: true,
          "tabs__button--active": currentTabPane === TabTypes.region
        }),
        type: "button",
        onClick: function onClick() {
          return setCurrentTabPane(TabTypes.region);
        }
      }, intl.formatMessage(_defineProperty({
        defaultMessage: "Region",
        "id": "components.MobileNav.NavLocales.2059998584"
      }, "id", "components.MobileNav.NavLocales.2059998584"))), React.createElement("button", {
        className: classNames({
          tabs__button: true,
          "tabs__button--active": currentTabPane === TabTypes.language
        }),
        type: "button",
        onClick: function onClick() {
          return setCurrentTabPane(TabTypes.language);
        }
      }, intl.formatMessage(_defineProperty({
        defaultMessage: "Language",
        "id": "components.MobileNav.NavLocales.604081953"
      }, "id", "components.MobileNav.NavLocales.604081953")))), React.createElement("div", {
        className: "locales__tabs-content"
      }, currentTabPane === TabTypes.region && React.createElement("div", null, React.createElement("div", {
        className: "tabs-content__desc"
      }, intl.formatMessage(_defineProperty({
        defaultMessage: "Select your region to see the relevant currency for you and shipping options.",
        "id": "components.MobileNav.NavLocales.3002668545"
      }, "id", "components.MobileNav.NavLocales.3002668545"))), React.createElement("div", {
        className: "locales__regions"
      }, React.createElement(RegionPicker, null))), currentTabPane === TabTypes.language && React.createElement("div", null, React.createElement("div", {
        className: "tabs-content__desc"
      }), React.createElement(LocalePicker, {
        onPicked: overlayContext.hide
      })))) : null;
    }));
  });
};